import cloudPlanImage from 'IMAGE/homepage/video-record-bg.webp';
import cloudPlanMobileImage from 'IMAGE/homepage/video-record-bg-m.webp';
import privacyImage from 'IMAGE/homepage/homepage-introducing.png';
import i18n from 'LANG';
import { config } from 'CONFIG';

interface IBaseFeatureIntroduction {
    title: string;
    subtitle: string;
    desc: string;
    note?: string;
    reverse?: boolean;
    backgroundColor?: string;
}

export interface IFeatureIntroductionWithImage extends IBaseFeatureIntroduction {
    type: 'video-record' | 'privacy';
    image: {
        pcImageSrc: string;
        mobileImageSrc: string;
        size: {
            width: number;
            height: number;
        };
    };
}
export interface IFeatureIntroductionWithVideo extends IBaseFeatureIntroduction {
    type: 'rich-notification';
    video: {
        src: string;
        poster: string;
        size: {
            width: number;
            height: number;
        };
    };
}

export type TFeatureIntroduction = IFeatureIntroductionWithImage | IFeatureIntroductionWithVideo;

const baseFeaturesList: TFeatureIntroduction[] = [
    {
        type: 'video-record',
        title: i18n.t( 'homepage.videoRecordTitlePC' ) as string,
        subtitle: i18n.t( 'homepage.videoRecordSubTitle' ) as string,
        desc: i18n.t( 'homepage.videoRecordDes' ) as string,
        image: {
            pcImageSrc: cloudPlanImage,
            mobileImageSrc: cloudPlanMobileImage,
            size: {
                width: 600,
                height: 600
            }
        },
        backgroundColor: '#f7f8f9'

    },
    {
        type: 'privacy',
        title: i18n.t( 'homepage.introducing_title' ) as string,
        subtitle: i18n.t( 'homepage.introducing_Subtitle' ) as string,
        desc: i18n.t( 'homepage.introducing_des' ) as string,
        image: {
            size: {
                width: 600,
                height: 525
            },
            pcImageSrc: privacyImage,
            mobileImageSrc: privacyImage
        },
        reverse: true,
        backgroundColor: '#fff'
    }
];

export const featuresList: TFeatureIntroduction[] = config.oem === 'reolink' ? baseFeaturesList.concat( [{
    type: 'rich-notification',
    title: i18n.t( 'homepage.rich_notification_title' ) as string,
    subtitle: '',
    desc: i18n.t( 'homepage.rich_notification_des' ) as string,
    note: i18n.t( 'homepage.rich_notification_note', i18n.locale, {
        link: config.richNotificationSupport
    }) as string,
    video: {
        src: `${config.videoCdn}/wp-content/assets/2022/09/rich-notification.mp4`,
        poster: `${config.imgCdn}/wp-content/assets/2022/09/rich-notification.jpg`,
        size: {
            width: 600,
            height: 525
        }
    }
}] ) : baseFeaturesList;
